import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Button } from 'reactstrap';
import { Link } from "react-router-dom";
import PageTitle from '../../../components/PageTitle/PageTitle';
import { Filters, Utils } from '../../../services/';

import './UsersList.css';
import { loadUsers, loadInactiveUsers } from '../../../redux/modules/users';
import Table from '../../../components/Table/Table';
import { mdiAccountOutline } from '@mdi/js';

const UsersList = props => {
    const [showActive, setShowActive] = useState(true);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadUsers());
        dispatch(loadInactiveUsers());
    }, [dispatch])

    const { t } = useTranslation();
    const {
        users,
        inactive_users,
    } = useSelector(state => state.users);

    const users_to_show = showActive ? users : inactive_users;

    const columns = React.useMemo(() =>[{
        Header: t('users.fullname'),
        accessor: "rfullname",
        width: '35%',
        filterMethod: Filters.textFilterMethod("rfullname"),
        Filter: Filters.textFilter,
        filterAll: true,
        Cell: row => <strong>{ row.value }</strong>
    }, {
        Header: t('users.email'),
        accessor: "email",
        width: '35%',
        filterMethod: Filters.textFilterMethod("email"),
        Filter: Filters.textFilter,
        filterAll: true,
    }, {
        Header: t('users.role'),
        id: 'role',
        accessor: 'role',
        width: '20%',
        filterMethod: Filters.rolesFilterMethod,
        Filter: Filters.rolesFilter,
        Cell: row => Utils.roles(row.value).label
    }, {
        Header: t('common.actions'),
        accessor: "id",
        width: '10%',
        filterable: false,
        className: 'text-center',
        Cell: row => (
            <>
                <ButtonGroup>
                    <Button tag={Link} to={"/users/show/" + row.value} outline color="primary" title={t('users.show')} >
                        <i className="fa fa-eye"></i>
                    </Button>
                    <Button tag={Link} to={"/users/edit/" + row.value} outline color="info" title={t('users.edit')} >
                        <i className="fa fa-edit"></i>
                    </Button>
                </ButtonGroup>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <ButtonGroup>
                    <Button tag={Link} to={"/users/delete/" + row.value} outline color="danger" title={t('common.delete')} >
                        <i className="fa fa-trash"></i>
                    </Button>
                </ButtonGroup>
            </>
        )
    }], [t]);

    const actions =
    <div>
        <ButtonGroup>
            <Button color={ showActive === true ? 'info' : 'secondary' } onClick={(e) => setShowActive(true)} size="sm">{ t('users.active') }</Button>
            <Button color={ showActive === false ? 'info' : 'secondary' } onClick={(e) => setShowActive(false)} size="sm">{ t('users.inactive') }</Button>
        </ButtonGroup>&nbsp;
        <Button tag={Link} to="/users/new" color="success" size="sm">
            <i className="fa fa-plus"></i>&nbsp;{t('users.add_a_user')}
        </Button>
    </div>;

    return (
        <div className="UsersList">
            <PageTitle icon={mdiAccountOutline} title={t('users.user_plural')} actions={ actions } />
            { users_to_show && (
                <Table
                    id="usersTable"
                    data={ users_to_show }
                    columns={ columns }
                    color="light" striped hover bordered sm responsive
                />
            )}
        </div>
    );
}

export default UsersList;
